import { render } from "./TournamentAgeCategoryList.vue?vue&type=template&id=698f0694&scoped=true"
import script from "./TournamentAgeCategoryList.vue?vue&type=script&lang=js"
export * from "./TournamentAgeCategoryList.vue?vue&type=script&lang=js"

import "./TournamentAgeCategoryList.vue?vue&type=style&index=0&id=698f0694&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-698f0694"]])

export default __exports__